import React, { FC, PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import LoadingIndicator from '../../common/LoadingIndicator/LoadingIndicator';

interface CartModelDisplayLoadingProps {
  width: number,
  height: number,
  loading: boolean,
}

const CartModelDisplayLoading: FC<PropsWithChildren<CartModelDisplayLoadingProps>> = ({
  children,
  width,
  height,
  loading
}) => (
  <Box sx={{ height: height }}>
    <Box sx={{ position: 'relative', height: 0 }}>
      <LoadingIndicator
        sx={{
          position: 'absolute',
          zIndex: 1031,
          left: (width - (width / 2)) / 2,
          top: (height - (width / 2)) / 2
        }}
        thickness={0.5}
        loading={loading}
        size={width / 2} />
    </Box>
    <Box sx={{
      opacity: 1,
      ...((loading)) && {
        opacity: 0.35
      }
    }}>
      {children}
    </Box>
  </Box >
);

export default CartModelDisplayLoading;
